export const PROPERTY_DETAIL_RETURN_KEY = "midpoint_property_detail_return";

export function resolvePropertyDetailId(property = {}) {
  return (
    property.canonicalPropertyId ||
    property.canonicalListingId ||
    property.canonical_property_id ||
    property.id ||
    property.listingId ||
    property.property_id ||
    null
  );
}

export function getPropertyDetailPath(propertyOrId) {
  const id =
    typeof propertyOrId === "string" || typeof propertyOrId === "number"
      ? propertyOrId
      : resolvePropertyDetailId(propertyOrId);

  if (!id) {
    return "/";
  }

  return `/real-estate/properties/${encodeURIComponent(id)}`;
}

/** Absolute URL for property detail (new tab / share links). */
export function getPropertyDetailUrl(propertyOrId) {
  const path = getPropertyDetailPath(propertyOrId);
  if (path === "/") {
    return path;
  }

  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}${path}`;
  }

  return path;
}

export function storePropertyDetailReturnState(state = {}) {
  try {
    sessionStorage.setItem(PROPERTY_DETAIL_RETURN_KEY, JSON.stringify(state));
  } catch {
    // Ignore quota errors.
  }
}

export function peekPropertyDetailReturnState() {
  try {
    const raw = sessionStorage.getItem(PROPERTY_DETAIL_RETURN_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function consumePropertyDetailReturnState() {
  const state = peekPropertyDetailReturnState();
  sessionStorage.removeItem(PROPERTY_DETAIL_RETURN_KEY);
  return state;
}

export function buildPropertyDetailReturnState({
  pathname = "/",
  search = "",
  hash = "",
  perspectiveId = null,
  realEstateFilters = null,
  realEstateViewMode = null,
  selectedPropertyId = null,
  mapView = null,
} = {}) {
  return {
    pathname,
    search,
    hash,
    perspectiveId,
    realEstateFilters,
    realEstateViewMode,
    selectedPropertyId,
    mapView,
    savedAt: Date.now(),
  };
}
